export default __webpack_public_path__ + "static/media/user.9cf1b7f7.svg";